export function initLeadForm() {
    const forms = document.querySelectorAll('.js-bt-lead-form');

    if (!forms.length) {
        return;
    }

    forms.forEach((form) => {
        if (form.dataset.btLeadBound === '1') {
            return;
        }

        form.dataset.btLeadBound = '1';

        const state = {
            submitting: false,
            renderedAtMs: Date.now(),
            renderedAtIso: new Date().toISOString(),
        };

        syncHiddenMeta(form, state);

        console.log('Lead form found:', form);

        form.addEventListener('submit', async (event) => {
            event.preventDefault();

            if (state.submitting) {
                return;
            }

            clearFormErrors(form);
            setFormStatus(form, '', '');

            state.submitting = true;
            setPendingState(form, true);

            try {
                const payload = buildLeadPayload(form, state);

                console.log('Lead payload:', payload);

                const endpoint =
                    window.BTLeadFormConfig?.restUrl || '/wp-json/bt/v1/lead';

                const response = await fetch(endpoint, {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                    },
                    body: JSON.stringify(payload),
                });

                let data = null;

                try {
                    data = await response.json();
                } catch (jsonError) {
                    data = null;
                }

                console.log('Lead response:', response.status, data);

                if (data?.ok) {
                    setFormStatus(
                        form,
                        'success',
                        data.message || 'Заявка отправлена'
                    );

                    form.reset();

                    state.renderedAtMs = Date.now();
                    state.renderedAtIso = new Date().toISOString();
                    syncHiddenMeta(form, state);

                    return;
                }

                if (data?.error === 'validation_error') {
                    if (data.fields && typeof data.fields === 'object') {
                        Object.entries(data.fields).forEach(([fieldPath, message]) => {
                            showFieldError(form, fieldPath, message);
                        });
                    }

                    setFormStatus(
                        form,
                        'error',
                        data.message || 'Проверьте заполнение полей'
                    );

                    return;
                }

                if (data?.error === 'spam_detected') {
                    setFormStatus(
                        form,
                        'error',
                        data.message || 'Не удалось отправить заявку'
                    );

                    return;
                }

                setFormStatus(
                    form,
                    'error',
                    data?.message || 'Не удалось отправить заявку, попробуйте еще раз'
                );
            } catch (error) {
                console.error('Lead submit failed:', error);

                setFormStatus(
                    form,
                    'error',
                    'Не удалось отправить заявку, попробуйте еще раз'
                );
            } finally {
                state.submitting = false;
                setPendingState(form, false);
            }
        });
    });
}

function buildLeadPayload(form, state) {
    const formData = new FormData(form);

    return {
        lead: {
            name: valueOrNull(formData.get('name')),
            phone: valueOrNull(formData.get('phone')),
            email: normalizeEmail(formData.get('email')),
            telegram: normalizeTelegram(formData.get('telegram')),
            project_type: valueOrNull(formData.get('project_type')),
            service_tags: getCheckedValues(form, 'service_tags[]'),
            object_type: valueOrNull(formData.get('object_type')),
            city: valueOrNull(formData.get('city')),
            message: valueOrNull(formData.get('message')),
        },
        context: {
            source: 'website',
            site: window.location.hostname,
            locale: getLocale(form),
            page_url: window.location.href,
            page_title: document.title || '',
            form_id: form.dataset.formId || '',
            form_name: form.dataset.formName || '',
            entrypoint: form.dataset.entrypoint || '',
            section: form.dataset.section || '',
            scenario: form.dataset.scenario || '',
        },
        meta: {
            submitted_at: new Date().toISOString(),
            timezone: getTimezone(),
            utm: getUtmObject(),
            referrer: document.referrer || '',
            client_id: getClientId(),
            user_agent: navigator.userAgent || '',
            consent: {
                privacy: !!formData.get('consent_privacy'),
                marketing: !!formData.get('consent_marketing'),
            },
            anti_spam: {
                honeypot: valueOrEmpty(formData.get('company')),
                rendered_at: state.renderedAtIso,
                submitted_after_ms: Date.now() - state.renderedAtMs,
            },
        },
    };
}

function syncHiddenMeta(form, state) {
    const pageUrlField = form.querySelector('[name="page_url"]');
    const pageTitleField = form.querySelector('[name="page_title"]');
    const renderedAtField = form.querySelector('[name="rendered_at"]');
    const honeypotField = form.querySelector('[name="company"]');

    if (pageUrlField) {
        pageUrlField.value = window.location.href;
    }

    if (pageTitleField) {
        pageTitleField.value = document.title || '';
    }

    if (renderedAtField) {
        renderedAtField.value = state.renderedAtIso;
    }

    if (honeypotField) {
        honeypotField.value = '';
    }
}

function setPendingState(form, isPending) {
    const submitButton = form.querySelector('.bt-cta-form__submit');

    form.classList.toggle('is-loading', isPending);
    form.setAttribute('aria-busy', isPending ? 'true' : 'false');

    if (!submitButton) {
        return;
    }

    if (!submitButton.dataset.originalText) {
        submitButton.dataset.originalText = submitButton.textContent;
    }

    submitButton.disabled = isPending;
    submitButton.textContent = isPending
        ? 'Отправка...'
        : submitButton.dataset.originalText;
}

function setFormStatus(form, type, message) {
    const status = form.querySelector('.bt-cta-form__status');

    if (!status) {
        return;
    }

    status.classList.remove('is-success', 'is-error');
    status.textContent = message || '';

    if (type === 'success') {
        status.classList.add('is-success');
    }

    if (type === 'error') {
        status.classList.add('is-error');
    }
}

function clearFormErrors(form) {
    form.querySelectorAll('.is-invalid').forEach((node) => {
        node.classList.remove('is-invalid');
    });

    form.querySelectorAll('.bt-field__error').forEach((node) => {
        node.remove();
    });
}

function showFieldError(form, fieldPath, message) {
    const target = resolveFieldTarget(form, fieldPath);

    if (!target) {
        return;
    }

    const container =
        target.closest('.bt-field') ||
        target.closest('.bt-consent') ||
        target.closest('.bt-checkgrid') ||
        target;

    if (!container) {
        return;
    }

    container.classList.add('is-invalid');

    const existing = container.querySelector('.bt-field__error');
    if (existing) {
        existing.textContent = message;
        return;
    }

    const errorNode = document.createElement('div');
    errorNode.className = 'bt-field__error';
    errorNode.textContent = message;
    container.appendChild(errorNode);
}

function resolveFieldTarget(form, fieldPath) {
    const fieldMap = {
        'lead.name': '[name="name"]',
        'lead.phone': '[name="phone"]',
        'lead.email': '[name="email"]',
        'lead.telegram': '[name="telegram"]',
        'lead.project_type': '[name="project_type"]',
        'lead.object_type': '[name="object_type"]',
        'lead.city': '[name="city"]',
        'lead.message': '[name="message"]',
        'lead.service_tags': '[name="service_tags[]"]',
        'meta.consent.privacy': '[name="consent_privacy"]',
        'context.form_id': '.js-bt-lead-form',
        'context.page_url': '[name="page_url"]',
        'context.source': '.js-bt-lead-form',
        'context.site': '.js-bt-lead-form',
        'meta.submitted_at': '.js-bt-lead-form',
        'meta.anti_spam.submitted_after_ms': '.js-bt-lead-form',
    };

    const selector = fieldMap[fieldPath];

    if (!selector) {
        return form.querySelector('.bt-cta-form__status');
    }

    return form.querySelector(selector);
}

function getCheckedValues(form, name) {
    return Array.from(form.querySelectorAll(`input[name="${name}"]:checked`))
        .map((input) => String(input.value || '').trim())
        .filter(Boolean);
}

function getLocale(form) {
    const raw =
        form.dataset.locale ||
        document.documentElement.lang ||
        document.body.getAttribute('lang') ||
        '';

    const normalized = String(raw)
        .trim()
        .toLowerCase()
        .replace('_', '-');

    if (!normalized) {
        return null;
    }

    const base = normalized.slice(0, 2);

    return ['ru', 'en', 'ka'].includes(base) ? base : null;
}

function getTimezone() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
    } catch (error) {
        return null;
    }
}

function getUtmObject() {
    const params = new URLSearchParams(window.location.search);

    return {
        source: valueOrNull(params.get('utm_source')),
        medium: valueOrNull(params.get('utm_medium')),
        campaign: valueOrNull(params.get('utm_campaign')),
        term: valueOrNull(params.get('utm_term')),
        content: valueOrNull(params.get('utm_content')),
    };
}

function getClientId() {
    const storageKey = 'bt_client_id';

    try {
        const existing = window.localStorage.getItem(storageKey);
        if (existing) {
            return existing;
        }

        const generated =
            typeof window.crypto?.randomUUID === 'function'
                ? window.crypto.randomUUID()
                : `bt-${Date.now()}-${Math.random().toString(16).slice(2)}`;

        window.localStorage.setItem(storageKey, generated);

        return generated;
    } catch (error) {
        return `bt-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    }
}

function normalizeEmail(value) {
    const prepared = valueOrNull(value);
    return prepared ? prepared.toLowerCase() : null;
}

function normalizeTelegram(value) {
    let prepared = valueOrNull(value);

    if (!prepared) {
        return null;
    }

    prepared = prepared
        .replace(/^https?:\/\/(www\.)?t\.me\//i, '')
        .replace(/^https?:\/\/(www\.)?telegram\.me\//i, '')
        .replace(/^@+/, '')
        .trim();

    return prepared ? `@${prepared}` : null;
}

function valueOrNull(value) {
    const prepared = String(value || '').trim();
    return prepared === '' ? null : prepared;
}

function valueOrEmpty(value) {
    return String(value || '').trim();
}